import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CardElement } from '@stripe/react-stripe-js';

import { Form } from '@/components/ui/form';
import { Alert } from '../../../../shared/components/Alert';
import {
  InputField,
  PasswordStrengthField,
  SubmitButton,
} from '../../../../shared/components/Form';
import { LOGIN } from '../../../shared/constants';
import Header from '../components/Header';
import { ERROR_TITLES } from '../constants';
import { useSignupForm } from '../hooks';

const alertIcon = <FontAwesomeIcon icon={faCircleExclamation} />;

const Signup = () => {
  const { error, form, handleSubmit: onSubmit, isSubmitting } = useSignupForm();

  const [businessName, email, firstName, lastName] = form.watch([
    'businessName',
    'email',
    'firstName',
    'lastName',
  ]);

  const strengthInputs = useMemo(
    () => [businessName, email, firstName, lastName],
    [businessName, email, firstName, lastName]
  );

  return (
    <div className="flex items-center justify-center bg-muted min-h-svh">
      <div className="flex flex-col gap-6 w-full max-w-xs">
        <Header title="Signup" />

        <Form {...form}>
          <form className="flex flex-col gap-6" onSubmit={form.handleSubmit(onSubmit)}>
            <InputField
              control={form.control}
              label="Business name"
              name="businessName"
            />

            <div className="flex gap-3">
              <InputField control={form.control} label="First name" name="firstName" />
              <InputField control={form.control} label="Last name" name="lastName" />
            </div>

            <InputField control={form.control} label="Email" name="email" type="email" />

            <PasswordStrengthField
              control={form.control}
              strengthInputs={strengthInputs}
            />

            <CardElement />

            <div className="flex flex-col gap-2">
              <SubmitButton isLoading={isSubmitting}>Create Account</SubmitButton>

              <p className="text-sidebar-foreground text-center">
                Already have an account? <Link to={LOGIN}>Log in</Link>
              </p>
            </div>

            {error && (
              <Alert
                description={error.message}
                icon={alertIcon}
                title={ERROR_TITLES.user.create}
                variant="destructive"
              />
            )}
          </form>
        </Form>
      </div>
    </div>
  );
};

export default Signup;
